import Resource from './resource';
import request from "../utils/request";

class StrategiesCard extends Resource {
    constructor() {
        super('strategies_card');
    }

    list(resource) {
        return request({
            url: `/strategies_card/list`,
            method: 'post',
            data: resource
        });
    }

    show(id) {
        return request({
            url: `/strategies_card/show/${id}`,
            method: 'get',
        });
    }

    store(resource) {
        return request({
            url: `/strategies_card/store`,
            method: 'post',
            data: resource
        });
    }

    update(id, resource) {
        return request({
            url: `/strategies_card/update/${id}`,
            method: 'post',
            data: resource
        });
    }

    delete(id) {
        return request({
            url: `/strategies_card/delete/${id}`,
            method: 'delete',
        });
    }

    restore(id) {
        return request({
            url: `/strategies_card/restore/${id}`,
            method: 'post',
        });
    }

    import(file) {
        const formData = new FormData();
        formData.append('file', file);

        return request({
            url: `/strategies_card/import`,
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    export(filters) {
        return request({
            url: `/strategies_card/export`,
            method: 'post',
            responseType: 'blob',
            data: filters || {}
        });
    }
}

export { StrategiesCard as default };
